import * as React from 'react'

import { CardListSummaryBar } from '~/client/src/shared/components/CardList/CardListSummaryBar'
import {
  ICardListItem,
  ICardListState,
} from '~/client/src/shared/components/CardList/types'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IItemsCounterLineProps<T extends ICardListItem> {
  visible: number
  total: number
  /** When provided, renders the multi-band toggle controls. Omit on surfaces that never group. */
  listState?: ICardListState<T>
}

export function ItemsCounterLine<T extends ICardListItem>({
  visible,
  total,
  listState,
}: IItemsCounterLineProps<T>): React.ReactElement {
  const isNarrowed = visible < total
  const text = isNarrowed
    ? Localization.translator.xOfYMapViews(visible, total)
    : Localization.translator.xMapViews(visible)
  return (
    <CardListSummaryBar
      listState={listState}
      // Reserves the room the overlaid header buttons occupy.
      trailing={
        <span
          aria-hidden="true"
          className="tw:ml-auto tw:h-8 tw:w-[82px] tw:shrink-0"
        />
      }
    >
      <span aria-live="polite">{text}</span>
    </CardListSummaryBar>
  )
}
